import React, { forwardRef } from "react";
import SoftButtonRoot from "./SoftButtonRoot";

interface SoftButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "small" | "medium" | "large";
  variant?: "text" | "contained" | "outlined" | "gradient";
  color?:
    | "white"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark";
  circular?: boolean;
  iconOnly?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
}

const SoftButton = forwardRef<HTMLButtonElement, SoftButtonProps>(
  (
    {
      size = "medium",
      variant = "contained",
      color = "white",
      circular = false,
      iconOnly = false,
      children,
      ...rest
    },
    ref
  ) => (
    <SoftButtonRoot
      {...rest}
      ref={ref}
      color="primary"
      variant={variant === "gradient" ? "contained" : variant}
      size={size}
      ownerState={{ color, variant, size, circular, iconOnly }}
    >
      {children}
    </SoftButtonRoot>
  )
);

SoftButton.displayName = "SoftButton";

export default SoftButton;
